import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AT = {
    SetConnectionStatus: 'transportStatus/setConnectionStatus',
    SetTransportError: 'transportStatus/setTransportError',
    SetTransportErrorKey: 'transportStatus/setTransportErrorKey',
    SetReportLoaded: 'transportStatus/setReportLoaded',
    SetThemeLoaded: 'transportStatus/setThemeLoaded',
    SetReportObjectContentComplete: 'transportStatus/setReportObjectContentComplete',
    SetPackageUrl: 'transportStatus/setPackageUrl',
    SetServerHost: 'transportStatus/setServerHost',
    SetServerType: 'transportStatus/SetServerType',
    SetIframeSandbox: 'transportStatus/SetIframeSandbox',
};
export const TransportState = {
    actions: {
        setConnectionStatus: (status) => action(AT.SetConnectionStatus, status),
        setTransportError: (error) => action(AT.SetTransportError, error),
        setTransportErrorKey: (errorKey) => action(AT.SetTransportErrorKey, errorKey),
        setReportLoaded: (loaded) => action(AT.SetReportLoaded, loaded),
        setThemeLoaded: (loaded) => action(AT.SetThemeLoaded, loaded),
        setReportObjectContentComplete: (contentComplete) => action(AT.SetReportObjectContentComplete, contentComplete),
        setPackageUrl: (packageUrl) => action(AT.SetPackageUrl, packageUrl),
        setServerHost: (serverHost) => action(AT.SetServerHost, serverHost),
        setServerType: (serverType) => action(AT.SetServerType, serverType),
        setIframeSandbox: (sandbox) => action(AT.SetIframeSandbox, sandbox),
    },
    actionTypes: AT,
    reducer: createReducer({
        connectionStatus: 'initalizing',
    }, {
        [AT.SetConnectionStatus]: (state, action) => {
            return Object.assign(Object.assign({}, state), { connectionStatus: action.payload });
        },
        [AT.SetTransportError]: (state, action) => {
            return Object.assign(Object.assign({}, state), { transportError: action.payload });
        },
        [AT.SetTransportErrorKey]: (state, action) => {
            return Object.assign(Object.assign({}, state), { transportErrorKey: action.payload });
        },
        [AT.SetReportLoaded]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportLoaded: action.payload });
        },
        [AT.SetThemeLoaded]: (state, action) => {
            return Object.assign(Object.assign({}, state), { themeLoaded: action.payload });
        },
        [AT.SetReportObjectContentComplete]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportObjectContentComplete: action.payload });
        },
        [AT.SetPackageUrl]: (state, action) => {
            return Object.assign(Object.assign({}, state), { packageUrl: action.payload });
        },
        [AT.SetServerHost]: (state, action) => {
            return Object.assign(Object.assign({}, state), { serverHost: action.payload });
        },
        [AT.SetServerType]: (state, action) => {
            return Object.assign(Object.assign({}, state), { serverType: action.payload });
        },
        [AT.SetIframeSandbox]: (state, action) => {
            return Object.assign(Object.assign({}, state), { iframeSandbox: action.payload });
        },
    }),
};
